import bash from 'refractor/lang/bash.js'
import graphql from 'refractor/lang/graphql.js'
import javascript from 'refractor/lang/javascript.js'
import jsx from 'refractor/lang/jsx.js'
import kotlin from 'refractor/lang/kotlin'
import markup from 'refractor/lang/markup.js'
import rust from 'refractor/lang/rust'
import sql from 'refractor/lang/sql'
import swift from 'refractor/lang/swift'
import toml from 'refractor/lang/toml'
import tsx from 'refractor/lang/tsx.js'
import typescript from 'refractor/lang/typescript.js'
import xml from 'refractor/lang/xml-doc'
import { refractor } from 'refractor/lib/core'
import rehypePrismGenerator from 'rehype-prism-plus/generator'

refractor.register(graphql)
refractor.register(bash)
refractor.register(markup)
refractor.register(javascript)
refractor.register(typescript)
refractor.register(jsx)
refractor.register(tsx)
refractor.register(rust)
refractor.register(swift)
refractor.register(kotlin)
refractor.register(xml)
refractor.register(sql)
refractor.register(toml)

export const rehypePrism = rehypePrismGenerator(refractor)

export const getLanguage = (language: string) => {
  switch (language) {
    case 'graphql':
    case 'gql':
    case 'sdl':
      return 'graphql'
    case 'javascript':
    case 'js':
      return 'js'
    case 'jsx':
      return 'jsx'
    case 'typescript':
    case 'ts':
      return 'ts'
    case 'tsx':
      return 'tsx'
    case 'markup':
    case 'html':
    case 'vue':
      return 'html'
    case 'rust':
      return 'rust'
    case 'kotlin':
      return 'kotlin'
    case 'swift':
      return 'swift'
    case 'xml':
      return 'xml'
    case 'sql':
    case 'postgres-sql':
    case 'postgres-psql':
    case 'postgres':
      return 'sql'
    case 'toml':
      return 'toml'
    case 'bash':
    case 'shell':
    default:
      return 'bash'
  }
}
